import classNames from 'classnames';
import React, { SyntheticEvent } from 'react';
import { useRecoilValue } from 'recoil';
import { assetPathFnState } from '../../recoil/atoms';
import styles from './SlimRadioOption.module.scss';

interface Props {
  isSelected: boolean | undefined;
  onClick: (event: SyntheticEvent) => void;
  dataKey: string | number | undefined;
  text?: string;
  iconName?: string;
}

export const SlimRadioOption: React.FC<Props> = ({ isSelected, onClick, dataKey, text, iconName }) => {
  const assetPathFn = useRecoilValue(assetPathFnState);

  return (
    <button className={classNames(styles.shadow, styles.slimRadio, { [styles.selected]: isSelected })} onClick={(event) => onClick(event)}>
      <div className={styles.radioContainer}>
        <input type="checkbox" checked={isSelected} onChange={() => null} value={dataKey} />
        <span className={styles.checkmark} />
        <span className={styles.uncheckmark} />
      </div>
      <span
        style={{
          fontSize: '1.1em',
        }}
      >
        {iconName && <img src={assetPathFn(iconName)} alt={text ?? ''} />}
        {(!iconName && text) ?? ''}
      </span>
    </button>
  );
};

export default SlimRadioOption;
